import { createSelector } from 'reselect'
import sumBy from 'lodash/sumBy'
import get from 'lodash/get'

import { Helpers } from '@homebot/shared-util-quartermaster'
import { selectHomeValue } from './metadata'
import { selectCurrentCELs } from './dictionary'

// TODO: TS state interface
type State = any

const getHomeSoldPrice = (state: State) => get(state, 'home.data.soldPrice')

const getAVMAppreciationPercent = (price: number, avm: number) =>
  price ? Helpers.getAppreciationPercent(avm, price) : null

export const selectAVMAppreciationPercent = createSelector(
  getHomeSoldPrice,
  selectHomeValue,
  getAVMAppreciationPercent
)

export const selectOutstandingPrincipal = createSelector(
  selectCurrentCELs,
  (dict: { loans: () => object[] }) =>
    sumBy(dict.loans(), 'progress.principalLeft')
)

const getAVMEquity = (currentValue: number, outstandingPrincipal: number) =>
  currentValue - outstandingPrincipal

export const selectAVMEquity = createSelector<State, number>(
  selectHomeValue,
  selectOutstandingPrincipal,
  getAVMEquity
)
